import { render } from "./Congrats.vue?vue&type=template&id=e6379be4"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__